import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {EQueryCCQuestion} from '../../../admin/e-query/models/e-query-c-c-question';

@Component({
    selector: 'e-query-c-c-question',
    template: require('./e-query-c-c-question.component.html'),
    styles: [require('./e-query-c-c-question.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EQueryCCQuestionComponent {
    @Input()
    public question: EQueryCCQuestion;

    public get issueTypeDescriptionText(): string {
        if (!this.question) {
            return '';
        }

        if (!this.question.issueDescription) {
            return this.question.issueType;
        }

        return `${this.question.issueType}/${this.question.issueDescription}`;
    }
}